import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconMachineSvg }  from '../../assets/icons/icon_machine_blue.svg';

const MachineIcon=(props)=>{
    return <Icon component={() => <IconMachineSvg />} {...props}/>
}

export default MachineIcon;